import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";

const ProductRecipe = () => {
  const [recipeList, setRecipeList] = useState([]);

  useEffect(() => {
    loadProductRecipe();
  }, []);

  async function loadProductRecipe() {
    const res = await api.get("/foodprocessor/product-recipe");
    if (res.status === 200) {
      setRecipeList(res.data);
    }
  }

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div
          style={{
            // backgroundColor: theme.palette.background.paper,
            padding: 0.25,
            paddingLeft: 0.5,
            paddingRight: 0.5,
            flexGrow: 1,
          }}
        >
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography variant="h6" mb={2}>
              Product Recipes
            </Typography>
            <ul>
              {recipeList.map((p, index) => (
                <li key={index}>{`${p.product_name} - ${p.serial_number}`}</li>
              ))}
            </ul>

            <Box>
              <Button
                onClick={() =>
                  (window.location.href = "/create-product-recipe")
                }
              >
                Create Product Recipe
              </Button>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default ProductRecipe;
